import React, { useState, useEffect } from 'react';

import Select from 'react-select';

import Text from 'common/components/Text/Text';
import { SessionState } from 'features/session/sessionSlice';
import { useAppSelector } from 'app/hooks';
import { CommonHash } from 'app/types';
import styles from './SelfIntroduction.module.scss';
import { DEGREE_TYPES, SUBJECT_TYPES } from 'common/constants';

interface CompProps {
  answers: CommonHash;
  setAnswer: (h: CommonHash) => void;
  // setSaveForm: (b: boolean) => void;
}

interface AcademicFormProps {
  index: number;
  answers: CommonHash;
  setAnswer: (h: CommonHash) => void;
}

const degreeTypeOptions = DEGREE_TYPES.map(([label, value]) => ({
  label: label,
  value: value,
}));

const subjectTypeOptions = SUBJECT_TYPES.map(([label, value]) => ({
  label: label,
  value: value,
}));

const AcademicForm = ({ index, answers, setAnswer }: AcademicFormProps): React.ReactElement => {
  const [historyAnswers, setHistoryAnswers] = useState<CommonHash>({});
  const setInputOption = (key: string, value: any) => {
    setHistoryAnswers((a: any) => ({ ...a, [key]: value }));
  };

  useEffect(() => {
    if (answers.user['academic_history'] && answers.user['academic_history'][index]) {
      setHistoryAnswers(answers.user['academic_history'][index]);
    }
  }, []);

  useEffect(() => {
    if (answers.user['academic_history']) {
      const list = [...answers.user['academic_history']];
      list.splice(index, 1, historyAnswers);
      setAnswer((a: any) => ({
        ...a,
        user: {
          ...a.user,
          academic_history: list,
        },
      }));
    } else {
      setAnswer((a: any) => ({
        ...a,
        user: {
          ...a.user,
          academic_history: [historyAnswers],
        },
      }));
    }
  }, [historyAnswers]);

  return (
    <div className={styles.inputsContainter}>
      <div className={styles.inputGroup}>
        <Text size={16} weight={600} inlineStyle={{ marginBottom: '12px' }} color="primary">
          School name
        </Text>
        <input
          className="form-control"
          type="text"
          onChange={(e) => setInputOption('school_name', e.target.value)}
          value={historyAnswers.school_name ? historyAnswers.school_name : ''}
        />
      </div>
      <div className={styles.inputGroup}>
        <Text size={16} weight={600} inlineStyle={{ marginBottom: '12px' }} color="primary">
          Degree type
        </Text>
        <Select
          isSearchable
          classNamePrefix="react-select"
          className={styles.selectInput}
          options={degreeTypeOptions}
          value={degreeTypeOptions.find((o: any) => o.value === historyAnswers['degree_type'])}
          onChange={({ value }: any) => setInputOption('degree_type', value)}
        />
      </div>
      <div className={styles.inputGroup}>
        <Text size={16} weight={600} inlineStyle={{ marginBottom: '12px' }} color="primary">
          Subject type
        </Text>
        <Select
          isSearchable
          classNamePrefix="react-select"
          className={styles.selectInput}
          options={subjectTypeOptions}
          value={subjectTypeOptions.find((o: any) => o.value === historyAnswers['subject_type'])}
          onChange={({ value }: any) => setInputOption('subject_type', value)}
        />
      </div>
    </div>
  );
};
const AcademicExperience = ({ answers, setAnswer }: CompProps): React.ReactElement => {
  const { user } = useAppSelector(({ session }: { session: SessionState }) => session);

  const [histories, setHistories] = useState([
    <AcademicForm index={0} key={0} answers={answers} setAnswer={setAnswer} />,
  ]);

  const handleAddAcademicHistory = (e: any) => {
    setHistories([
      ...histories,
      <AcademicForm
        index={histories.length}
        key={histories.length}
        answers={answers}
        setAnswer={setAnswer}
      />,
    ]);
  };

  const handleRemoveAcademicHistory = (index: number) => {
    const list = [...histories];
    list.splice(index, 1);
    setHistories(list);
    const academicHistories = [...answers['academic_history']];
    academicHistories.splice(index, 1);
    setAnswer((a: any) => ({
      ...a,
      academic_history: academicHistories,
    }));
  };

  useEffect(() => {
    if (user?.['academic_history'] && user['academic_history'].length) {
      const prevHistories: any = [];
      user['academic_history'].map((h, index) => {
        prevHistories.push(
          <AcademicForm index={index} key={index} answers={answers} setAnswer={setAnswer} />
        );
      });
      setHistories(prevHistories);
    }
  }, []);

  return (
    <div className={styles.stepContainer}>
      <Text size={24} weight={600} color="primary" inlineStyle={{ marginBottom: '40px' }}>
        My highest level of education
      </Text>
      {histories.map((history, index) =>
        index == 0 ? (
          history
        ) : (
          <div className={styles.historyContainer} key={index}>
            <hr />
            <div
              className={styles.deleteHistory}
              onClick={() => handleRemoveAcademicHistory(index)}
            >
              <i className="bi bi-trash"></i>
            </div>
            {history}
          </div>
        )
      )}
      <div className={styles.addMoreHistoryBox} onClick={handleAddAcademicHistory}>
        <Text>Add more education history</Text>
        <i className="bi bi-plus"></i>
      </div>
    </div>
  );
};

export default AcademicExperience;
